import {clamp, texture} from "p3";

export default class TutorialPointer extends PIXI.Container {
    constructor() {
        super();

        this._pointer = null;
        this._from = null;
        this._to = null;
        this._offset = new PIXI.Point();

        this._bounceTime = 0;

        this.init();
    }

    init() {
        this._pointer = new PIXI.Sprite(texture("tutorial_pointer"));
        this._pointer.anchor.set(0, 0.5);
        this._pointer.visible = false;
        this.addChild(this._pointer);
    }

    update() {
        if (this._from && this._to) {
            const to = new P3.Vector2((this._to.x + this._offset.x) - this._from.x, (this._to.y + this._offset.y) - this._from.y);
            const angle = to.angle;
            const radius = 74;
            this._pointer.x = Math.cos(angle) * radius;
            this._pointer.y = Math.sin(angle) * radius;
            this._pointer.rotation = angle;

            const bounce = 0.8 + Math.sin(this._bounceTime) * 0.02;
            this._pointer.scale.set(bounce);
            this._bounceTime += 8 * window.dt;

            this._pointer.alpha = clamp((to.lengthSq - (120 ** 2)) / (300 ** 2), 0, 1);
        }
    }

    /**
     * @param {Entity} from
     * @param {Entity} to
     * @param {PIXI.Point} [offset=new PIXI.Point]
     */
    setDirection(from, to, offset= new PIXI.Point()) {
        this._from = from;
        this._to = to;
        this._offset = offset;
        this._pointer.visible = from && to;
    }
}